export default __webpack_public_path__ + "media/Non-food-Detergent.7e859859.png";